export default __webpack_public_path__ + "static/media/svg-phone.c8108342.svg";